import React from "react";

import { trackEvent } from "../lib/analytics";
import { trackPlatformEvent } from "../lib/platformAnalytics";

const VIBEBEE_ROUTE = "/vibebee";

function trackVibeBeePromoClick() {
  trackEvent("vibebee_homepage_promo_click", {
    page_path: "/",
    destination_url: VIBEBEE_ROUTE,
    source_section: "homepage_vibebee_promo",
  });

  void trackPlatformEvent("vibebee_homepage_promo_click", {
    page_path: "/",
    category: "vibebee",
    metadata_json: { source_section: "homepage_vibebee_promo" },
  });
}

export default function VibeBeeHomepagePromo() {
  const tracked = React.useRef(false);

  React.useEffect(() => {
    if (tracked.current) return;

    tracked.current = true;
    trackEvent("vibebee_homepage_promo_view", {
      page_path: "/",
      source_section: "homepage_vibebee_promo",
    });
    void trackPlatformEvent("vibebee_homepage_promo_view", {
      page_path: "/",
      category: "vibebee",
      metadata_json: { source_section: "homepage_vibebee_promo" },
    });
  }, []);

  return (
    <section className="relative mt-7 overflow-hidden rounded-[30px] border border-fuchsia-400/24 bg-[#120f12]/82 text-white shadow-[0_28px_80px_rgba(0,0,0,0.36)] backdrop-blur-2xl">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-fuchsia-400/70 to-transparent" />
      <div className="pointer-events-none absolute -right-24 -top-24 h-56 w-56 rounded-full bg-fuchsia-500/18 blur-[92px]" />
      <div className="pointer-events-none absolute -bottom-24 left-8 h-52 w-52 rounded-full bg-[#f0c66a]/12 blur-[85px]" />

      <div className="relative z-10 flex flex-col items-center px-5 pb-6 pt-4 text-center sm:px-6 sm:pb-7 sm:pt-5 lg:px-8 lg:pb-8">
        <a
          href={VIBEBEE_ROUTE}
          onClick={trackVibeBeePromoClick}
          aria-label="Ask VibeBee, your Costa del Sol AI guide"
          className="group relative mb-2 flex w-full max-w-[230px] items-center justify-center focus:outline-none focus-visible:ring-2 focus-visible:ring-fuchsia-300 sm:max-w-[260px] lg:max-w-[280px]"
        >
          <span aria-hidden="true" className="pointer-events-none absolute bottom-3 h-10 w-36 rounded-full bg-fuchsia-400/24 blur-2xl" />
          <img
            src="/images/vibebee-mascot.webp"
            alt="Official VibeBee character"
            className="vibebee-float pointer-events-none relative z-10 h-auto w-full object-contain drop-shadow-[0_24px_40px_rgba(255,46,196,0.28)] transition duration-300 group-hover:scale-[1.02]"
            loading="lazy"
            decoding="async"
            width="220"
            height="316"
          />
        </a>

        <p className="inline-flex rounded-full border border-fuchsia-400/28 bg-fuchsia-500/10 px-3 py-1 text-[11px] font-black uppercase tracking-[0.22em] text-fuchsia-200">
          Public AI Concierge
        </p>

        <h2 className="mt-4 text-3xl font-black leading-tight text-white sm:text-4xl">
          Meet VibeBee 🐝
        </h2>

        <p className="mt-2 text-xl font-black leading-tight text-[#f0c66a] sm:text-2xl">
          Your Costa del Sol AI guide.
        </p>

        <p className="mx-auto mt-3 max-w-2xl text-sm leading-6 text-white/72 sm:text-base">
          Ask what’s on, where to eat, where to drink, what’s nearby or how to get there.
        </p>

        <a
          href={VIBEBEE_ROUTE}
          onClick={trackVibeBeePromoClick}
          className="relative z-20 mt-5 inline-flex min-h-[46px] items-center justify-center rounded-full bg-gradient-to-r from-[#f0c66a] via-[#e7a94f] to-fuchsia-500 px-6 py-3 text-sm font-black uppercase tracking-[0.12em] text-black shadow-[0_18px_42px_rgba(240,198,106,0.22)] transition hover:scale-[1.02] focus:outline-none focus-visible:ring-2 focus-visible:ring-fuchsia-300"
        >
          ASK VIBEBEE →
        </a>
      </div>
    </section>
  );
}
